import React from "react";
import MaskInput from "react-maskinput";
import LcField from "./LcField";

export default function MaskedTextField(props) {
  return (
    <LcField
      name={props.name}
      text={props.text}
      errorMessage={props.errorMessage}
    >
      <MaskInput
        className="input-md"
        id={props.name}
        mask="00/00/0000"
        maskString="MM/DD/YYYY"
        size={20}
        {...props}
      />
    </LcField>
  );
}
